const mapStrings = {
  dashboard: 'Genel Bakış',
  smsGroup: 'Gruba SMS',
  smsExcel: 'Excel ile SMS',
  smsSpecialExcel: 'Gelişmiş Excel ile SMS',
  smsBulk: 'Numaralara SMS',
  smsSelective: 'Seçili Numaralara SMS',
  smsOne: 'Tek Numaraya SMS',
  contact: 'Kayıt Oluşturma',
  contactDetail: 'Rehber Kaydı',
  sender: 'Gönderilen Gönderici Adları',
  cancel: 'İptal İşlemleri',
  blacklist: 'Karaliste',
  report: 'Raporlar',
  reportDetail: 'Rapor Detayları',
  reportSearch: 'Raporlarda Arama',
  prices: 'Paket Fiyatları',
  projects: 'VATANSOFT Bünyesindeki Diğer Projeler',
  bank: 'Banka Hesapları',
  settings: 'Ayarlar',
  subUser: 'Alt Kullanıcı İşlemleri',
  payment: 'Geçmiş Ödemeler',
  paymentNotify: 'Ödeme Bildirimi',
  template: 'Şablonlar',
  templateCreate: 'Şablon Oluştur',
  templateUpdate: 'Şablon Güncelle',
  groupContacts: 'Grup/Rehber İşlemleri',
  groups: 'Grup İşlemleri',
  contactCreate: 'Rehber Kaydı Oluştur',
  notifications: 'Bildirimler',
  birthday: 'Doğum Günü şablonu',
  incoming: 'Gelen Mesajlar',
  iysPermissionAdd: 'İYS İzin Ekle',
  iysReport: 'IYS Raporu',
  iysExcel: 'Excel ile izin ekle',
  iysQuery: 'İzin Sorgula',
  iysBlockedList: 'İYS Engellenenler Listesi',
  iysBlockedDetail: 'İYS Engellenen Detayı',
  myBrands: 'Markalarım',
  contactList:"Rehber Listesi",
};

export default {
  mapStrings,
};
